// extracted by mini-css-extract-plugin
module.exports = {"button":"button-27meZ","button_disabled":"button_disabled-23Bf-","counter":"counter-cDUSx","value":"value-1A8Ze"};